(() => {
  const publish = (name, detail = {}) => {
    window.gtag?.('event', name, detail);
    window.Shopify?.analytics?.publish?.(`zoomtec_${name}`, detail);
  };

  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const revealTargets = [...document.querySelectorAll('.ztv3-section, .ztv3-studio, .ztv3-brochure, .ztv3-final')];
  if (!reducedMotion && 'IntersectionObserver' in window && revealTargets.length) {
    document.documentElement.classList.add('ztv3-js');
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ztv3-reveal--visible');
          instance.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
    revealTargets.forEach((target) => observer.observe(target));
    window.setTimeout(() => {
      revealTargets.forEach((target) => target.classList.add('ztv3-reveal--visible'));
      observer.disconnect();
    }, 1400);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    const detail = { link_text: (link.textContent || '').trim().slice(0, 80), link_url: href };
    if (href.startsWith('mailto:')) publish('email_click', detail);
    if (href.startsWith('tel:')) publish('phone_click', detail);
    if (href.includes('intent=studio-visit')) publish('studio_cta', detail);
    if (href.includes('intent=bring-plans')) publish('bring_your_plans', detail);
    if (href.includes('#brochure-preview')) publish('brochure_view', { source_page: window.location.pathname });
  });

  document.querySelectorAll('[data-brochure-form]').forEach((form) => {
    let started = false;
    form.addEventListener('focusin', () => {
      if (started) return;
      started = true;
      publish('brochure_form_start', { source_page: window.location.pathname, brochure_version: form.dataset.brochureVersion || 'unknown' });
    });
    form.addEventListener('submit', () => {
      publish('brochure_form_submit', { source_page: window.location.pathname, brochure_version: form.dataset.brochureVersion || 'unknown' });
    });
  });

  document.querySelectorAll('[data-brochure-download]').forEach((link) => {
    link.addEventListener('click', () => publish('brochure_download', { source_page: window.location.pathname, brochure_version: 'A4-LANDSCAPE-V3' }));
  });
})();
